import { render, staticRenderFns } from "./GLTFViewer.vue?vue&type=template&id=6b07ebe4&scoped=true&"
import script from "./GLTFViewer.vue?vue&type=script&lang=js&"
export * from "./GLTFViewer.vue?vue&type=script&lang=js&"
import style0 from "./GLTFViewer.vue?vue&type=style&index=0&id=6b07ebe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07ebe4",
  null
  
)

export default component.exports